import script from "./MazdaPluginPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaPluginPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaPluginPanel.vue?vue&type=style&index=0&id=f8b0cc2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8b0cc2a"]])

export default __exports__